// import { useState, useEffect } from 'react';
// import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';

import { AppContextProvider } from '../../context/AppContext';

import { routeTypes } from '../../hooks/useSystemRoutes';

import { getLayoutFrame } from "../../configs/layoutFrameConfigs"

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

export default function PublicLayout() {

  const RenderFrameComponent = () => {

    return getLayoutFrame({ routeType: routeTypes.public })
  }

  return (
    <AppContextProvider>
      <StyledRoot>

        <RenderFrameComponent />

      </StyledRoot>
    </AppContextProvider>
  );
}
